export var ONE_INCH_TO_MM = 25.4;
export var ENDLESS_PAGE_MINIMUM_LENGTH_MM = 7;
